import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { baseDirectReplaces, baseReplaces, replaces } from '../configs/tsconfig-config';

export class TSConfigUpgrader {
    private filePath: string;
    private fileWriter: FileWriter;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     * @param fileName the file name.
     */
    constructor(filePath: string, fileName?: string) {
        this.filePath = filePath;
        this.messages.notFound = `${fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors for base config.
     */
    public async runBase(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .replaceTsConfigContent(baseReplaces)
                    .replaceContent(baseDirectReplaces)
                    .writeFile();
            } else {
                Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .replaceTsConfigContent(replaces)
                    .writeFile();
            } else {
                    Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
